import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { INTEGRATIONTYPES } from '../../../../constants/applicationConstants';
import {
  DataTableHoc,
  Loader,
  ErrorFallback,
  deleteFilter,
  applyFilter,
  saveFilters,
} from 'smart-react';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../../constants/applicationConstants';
const BaseCommandDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable'),
);
const IntegrationTypeDataTable = DataTableHoc(BaseCommandDataTable);

/**
 * IntegrationType main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The IntegrationType component.
 */
const IntegrationType = () => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className='container mx-auto'>
        <React.Suspense fallback={<Loader />}>
          <IntegrationTypeDataTable
            deleteFilter={deleteFilter}
            applyFilter={applyFilter}
            saveFilters={saveFilters}
            moduleName={INTEGRATIONTYPES}
            dataColumns={dataColumnsArray}
            gridColumnsList={GridColumnsList}
            dataTableName={INTEGRATIONTYPES}
            setIsReady={setIsReady}
            isReady={isReady}
            rowLayoutConfigName={`${INTEGRATIONTYPES}.DataGrid.RowLayout`}
            pageLengthConfigName={`${INTEGRATIONTYPES}.DataGrid.ItemsPerPage`}
            dataSet={userData}
            setDataSet={setUserData}
            isCardonMobileView={false}
            total={process.env.DefaultLimit}
            defaultRowLayout={process.env.RowLayout}
            rowLayouts={ROW_LAYOUTS}
            pageSizes={PAGE_SIZE}
            isDefaultSlider={true}
            contentSliderTitle={'Integration Type'}
          />
        </React.Suspense>
      </div>
    </ErrorBoundary>
  );
};
export default IntegrationType;
